import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1OrganizationRecordValuesList: build.query<
      ApiAdminV1OrganizationRecordValuesListApiResponse,
      ApiAdminV1OrganizationRecordValuesListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    apiAdminV1OrganizationRecordValuesCreate: build.mutation<
      ApiAdminV1OrganizationRecordValuesCreateApiResponse,
      ApiAdminV1OrganizationRecordValuesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/`,
        method: "POST",
        body: queryArg.organizationRecordValueCreateUpdate,
      }),
    }),
    apiAdminV1OrganizationRecordValuesRetrieve: build.query<
      ApiAdminV1OrganizationRecordValuesRetrieveApiResponse,
      ApiAdminV1OrganizationRecordValuesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/${queryArg.id}/`,
      }),
    }),
    apiAdminV1OrganizationRecordValuesUpdate: build.mutation<
      ApiAdminV1OrganizationRecordValuesUpdateApiResponse,
      ApiAdminV1OrganizationRecordValuesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.organizationRecordValueCreateUpdate,
      }),
    }),
    apiAdminV1OrganizationRecordValuesDestroy: build.mutation<
      ApiAdminV1OrganizationRecordValuesDestroyApiResponse,
      ApiAdminV1OrganizationRecordValuesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-record-values/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1OrganizationRecordValuesListApiResponse =
  /** status 200  */ OrganizationRecordValueRead[];
export type ApiAdminV1OrganizationRecordValuesListApiArg = {
  /** ID of the organization */
  organizationId?: number;
};
export type ApiAdminV1OrganizationRecordValuesCreateApiResponse =
  /** status 201  */ OrganizationRecordValueRead;
export type ApiAdminV1OrganizationRecordValuesCreateApiArg = {
  organizationRecordValueCreateUpdate: OrganizationRecordValueCreateUpdate;
};
export type ApiAdminV1OrganizationRecordValuesRetrieveApiResponse =
  /** status 200  */ OrganizationRecordValueRead;
export type ApiAdminV1OrganizationRecordValuesRetrieveApiArg = {
  /** A unique integer value identifying this organization record value. */
  id: number;
};
export type ApiAdminV1OrganizationRecordValuesUpdateApiResponse =
  /** status 200  */ OrganizationRecordValueRead;
export type ApiAdminV1OrganizationRecordValuesUpdateApiArg = {
  /** A unique integer value identifying this organization record value. */
  id: number;
  organizationRecordValueCreateUpdate: OrganizationRecordValueCreateUpdate;
};
export type ApiAdminV1OrganizationRecordValuesDestroyApiResponse = unknown;
export type ApiAdminV1OrganizationRecordValuesDestroyApiArg = {
  /** A unique integer value identifying this organization record value. */
  id: number;
};
export type OrganizationRecordValue = {
  id: number;
  name: string;
  type_of_value: number;
  sort_order: number;
  max_range: number;
  min_range: number;
  created_at: string;
};
export type OrganizationRecordValueRead = {
  id: number;
  name: string;
  type_of_value: number;
  sort_order: number;
  max_range: number;
  min_range: number;
  organization: string;
  created_at: string;
};
export type OrganizationRecordValueCreateUpdateTypeOfValueEnum = 1 | 2 | 3 | 4;
export type OrganizationRecordValueCreateUpdate = {
  id?: number;
  name: string;
  type_of_value: OrganizationRecordValueCreateUpdateTypeOfValueEnum;
  sort_order?: number;
  max_range?: number;
  min_range?: number;
  organization: number;
};
export const {
  useApiAdminV1OrganizationRecordValuesListQuery,
  useApiAdminV1OrganizationRecordValuesCreateMutation,
  useApiAdminV1OrganizationRecordValuesRetrieveQuery,
  useApiAdminV1OrganizationRecordValuesUpdateMutation,
  useApiAdminV1OrganizationRecordValuesDestroyMutation,
} = injectedRtkApi;
